import { use as fegoUse } from '@fegobull/webapi';
import { ActivityResultCode } from '@ark/nup-shared';
import { getCopy } from '../constants/copy';

function errorText(isEn: boolean): Record<number, string> {
  const copy = getCopy(isEn);
  return {
    [ActivityResultCode.ENROLL_ENDED]: copy.enrollEnded,
    [ActivityResultCode.UDP_MISS]: copy.udpMiss,
    [ActivityResultCode.STATUS_NOT_ALLOWED]: copy.statusNotAllowed,
    [ActivityResultCode.CHOICE_NOT_ALLOWED]: copy.choiceNotAllowed,
    [ActivityResultCode.INVALID_CHOICE]: copy.invalidChoice,
  };
}

export function showToast(message: string): void {
  if (!message) {
    return;
  }
  const { useToast } = fegoUse;
  const toastApi = useToast() as {
    msg: (text: string, options?: Record<string, unknown>) => void;
  };
  setTimeout(() => {
    toastApi.msg(message, { duration: 2000 });
  }, 50);
}

export function extractBusinessCode(error: unknown): number | null {
  if (!error || typeof error !== 'object') {
    return null;
  }
  const rec = error as Record<string, unknown>;
  const raw = rec.businessCode ?? rec.code;
  const code = Number(raw);
  if (!Number.isFinite(code) || code === 0) {
    return null;
  }
  return code;
}

export function resolveApiErrorToast(
  error: unknown,
  fallback?: string,
  isEn = false,
): string {
  const copy = getCopy(isEn);
  const resolvedFallback = fallback || copy.opFailed;
  const table = errorText(isEn);
  const code = extractBusinessCode(error);
  if (code != null) {
    const mapped = table[code] || table[code % 100000];
    if (mapped) {
      return mapped;
    }
  }
  if (error && typeof error === 'object') {
    const data = (error as { data?: unknown }).data;
    if (typeof data === 'string' && data) {
      return data;
    }
  }
  return resolvedFallback;
}

export function toastApiError(
  error: unknown,
  fallback?: string,
  isEn = false,
): void {
  showToast(resolveApiErrorToast(error, fallback, isEn));
}
